export const ADMIN_ROLE_NAME = "Admin";

// Display-only hint for showing/hiding nav links. localStorage is user-editable, so this must
// never gate anything: AdminRoute re-checks the role with the server and the API enforces 403.
export const isAdminHint = () => localStorage.getItem("role") === ADMIN_ROLE_NAME;
